module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplement-types text-dark"
  }, [_c('div', {
    staticClass: "supplement-types__header"
  }, [_c('div', {
    staticClass: "supplement-types__header__left"
  }, [_c('h2', [_vm._v("Faste tillæg")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header__left"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsCreateModal(true)
      }
    }
  }, [_vm._v("Opret tillæg")])])]), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header"
  }, [_c('div', {
    staticClass: "supplement-types__header__left"
  }, [_c('Tabs', {
    attrs: {
      "tabs": [{
          id: '',
          title: 'Alle'
        },
        {
          id: '(Lønbrøk)',
          title: 'Lønbrøk'
        },
        {
          id: 'undervisningstillæg',
          title: 'UV-tillæg'
        },
        {
          id: 'opgaver',
          title: 'Opgaver'
        } ],
      "selected": _vm.selectedTab
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isDownloading
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownloadSimple
    }
  }, [_vm._v("\n        Download\n        to excel\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header__left"
  }, [(_vm.selectedTab === '(Lønbrøk)') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('lønbrøk')
      }
    }
  }, [_vm._v("\n        Hent lønbrøk\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'undervisningstillæg') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('undervisningstillæg')
      }
    }
  }, [_vm._v("\n        Hent UV-timer over 750\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('opgaver')
      }
    }
  }, [_vm._v("\n        Hent opgaver med tillæg\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setIsShowTasksModal(true)
      }
    }
  }, [_vm._v("\n        Tilføj tillægstyper til opgaver\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
    staticClass: "do-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.supplementsFiltered.length === 0) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.supplementsFiltered), function(supplement) {
    return _c('tr', {
      key: supplement.id,
      staticClass: "supplement-list-item",
      on: {
        "click": function($event) {
          return _vm.setEditSupplement(supplement)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(supplement.vUserName))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.year_norm_hours))]), _vm._v(" "), _c('td', {
      staticClass: "width-period"
    }, [_vm._v(_vm._s(_vm.formatPeriod(supplement.valid_period)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.account || '—'))]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.installments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units_per_installment)))])])
  })], 2)])]), _vm._v(" "), (_vm.isCreateModal) ? _c('CreateSupplement', {
    attrs: {
      "isSubmitting": _vm.isSubmitting,
      "supplementTypes": _vm.supplementTypes,
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "schoolYear": _vm.schoolYear,
      "editSupplement": _vm.editSupplement
    },
    on: {
      "save": _vm.createSupplement,
      "update": _vm.updateSupplement,
      "close": function($event) {
        return _vm.setIsCreateModal(false)
      },
      "delete": _vm.deleteSupplement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTasksModal) ? _c('TaskOverviewSettings', {
    attrs: {
      "isSupplements": true,
      "supplementTypes": _vm.supplementTypes
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowTasksModal(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Identitet")]), _vm._v(" "), _c('th', [_vm._v("Brutto årsnorm")]), _vm._v(" "), _c('th', {
    staticClass: "width-period"
  }, [_vm._v("Beregningsperiode")]), _vm._v(" "), _c('th', [_vm._v("Tillægstype")]), _vm._v(" "), _c('th', [_vm._v("Konto")]), _vm._v(" "), _c('th', [_vm._v("Enheder overtid")]), _vm._v(" "), _c('th', [_vm._v("Enheder i periode")]), _vm._v(" "), _c('th', [_vm._v("Antal udbetalinger")]), _vm._v(" "), _c('th', [_vm._v("Enh. pr måned")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_c('i', [_vm._v("Ingen oprettet i skoleåret")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1056088!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/SupplementsList.vue
// module id = 1798
// module chunks = 1